import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Import the functions you need from the SDKs you need
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAM6mQr9SYNHr0aAMMNQceJjfYkL1G1lSk",
  authDomain: "connect-overseas-visa-in-59937.firebaseapp.com",
  projectId: "connect-overseas-visa-in-59937",
  storageBucket: "gs://connect-overseas-visa-in-59937.firebasestorage.app",
  messagingSenderId: "226796587503",
  appId: "1:226796587503:web:83478d5e84ef6c54450e1a",
  measurementId: "G-CKLQ8FPP95"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

export const auth = getAuth(app);
export const firestore = getFirestore(app);
export const storage = getStorage(app); 